// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"styles_tableContainer__3P8Ml","table":"styles_table__19AfL","registrationNumberValue":"styles_registrationNumberValue__2UuYU"};